import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { withRouter } from 'react-router';
import ImmutablePropTypes from 'react-immutable-proptypes';
import UserStore from '../../stores/UserStore';
import AdminActions from '../../actions/AdminActions';
import UserAdminTable from '../../components/UserAdminTable.react';

function getUserState() {
  return {
    users: UserStore.getUserList(),
  };
}

class UserTableContainer extends Component {
  constructor(props) {
    super(props);
    this.state = getUserState();

    this.goToNew = this.goToNew.bind(this);
    this.goToUser = this.goToUser.bind(this);
    this._onChange = this._onChange.bind(this);
  }

  UNSAFE_componentWillMount() {
    AdminActions.loadUsersForCurrentOrganization();
  }

  componentDidMount() {
    this.userSubscription = UserStore.addListener(this._onChange);
  }

  componentWillUnmount() {
    this.userSubscription.remove();
  }

  goToNew() {
    this.props.router.push('/admin/user/new');
  }

  goToUser(user) {
    this.props.router.push(`/admin/user/${user.id}`)
  }

  _onChange() {
    this.setState(getUserState());
  }

  render() {
    return (
      <div className='userManager'>
        <h3>Manage Users</h3>
        <UserAdminTable
          users={this.state.users}
          onNewClick={this.goToNew}
          onUserClick={this.goToUser}
        />
      </div>
    );
  }
}

UserTableContainer.propTypes = {
  users: ImmutablePropTypes.iterableOf(
    PropTypes.shape({
      id: PropTypes.number,
      email: PropTypes.string,
    }),
  ),
};

export default withRouter(UserTableContainer);
